"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FilteredUserInfoChat = void 0;
const mappers_1 = require("../../mappers");
const models_1 = require("../../models");
const Observable_1 = require("../../socket/Observable");
const DomainEvents_1 = require("../../utils/DomainEvents");
const FilteredChat_1 = __importDefault(require("../FilteredChat"));
class FilteredUserInfoChat extends FilteredChat_1.default {
    constructor(chat, organizationUser, httpAdapter, socketAdapter, userDirectory) {
        super(chat, organizationUser, httpAdapter, socketAdapter, userDirectory);
    }
    init() {
        super.init();
        this.removeListeners.push(this.onUserUpdate());
    }
    onUserUpdate() {
        return Observable_1.Observable.getInstance().subscribe((0, DomainEvents_1.getEventKey)(DomainEvents_1.DomainEvents.USER_UPDATE, this.organizationUser.getOrganizationId()), (data) => {
            if ((data === null || data === void 0 ? void 0 : data._id) !== this.chatInfo.id)
                return;
            const mapped = (0, mappers_1.userInfoMapper)(data);
            this._chatInfo = Object.assign(Object.assign({}, this._chatInfo), mapped);
            this.notifyChange();
        });
    }
    getChatId() {
        return this.chatInfo.id;
    }
    getChatType() {
        return models_1.CHAT_TYPE.PRIVATE;
    }
}
exports.FilteredUserInfoChat = FilteredUserInfoChat;
